import { GapDialogProps } from 'reusable/gap-dialog/GapDialog'
import { messageActions } from './message-actions'
import { GapDialogAction } from 'reusable/gap-dialog/GapDialogActionButton'
interface messageConfirmProps extends Omit<GapDialogProps, 'actions'> {
   confirmButtonTitle?: string
}
export async function messageConfirm(children: messageConfirmProps['children'], title?: string, options?: messageConfirmProps & { variant?: GapDialogAction['variant'] }): Promise<boolean> {
   const { confirmButtonTitle, ...otherOptions } =
      !!options ? options : { confirmButtonTitle: undefined, cancelButtonTitle: undefined }

   const confirm = confirmButtonTitle ?? 'Ok'
   const answer = await messageActions({
      title: title,
      children: children,
      primary: {
         name: confirm,
         variant: options?.variant
      },
      cancel: true,
      ...otherOptions,
   })

   if (!!answer && answer.name === confirm) {
      return true
   }

   return false
}
